import { useTranslation } from 'react-i18next';

export default function OrgFilters({ facets, filters, onChange, onClear, activeCount }) {
  const { t } = useTranslation();

  function update(patch) {
    onChange({ ...filters, ...patch });
  }

  return (
    <aside className="space-y-6">
      <header className="flex items-center justify-between">
        <h2 className="font-serif text-lg text-gold-light">{t('common.filter')}</h2>
        {activeCount > 0 && (
          <button
            type="button"
            onClick={onClear}
            className="text-xs font-medium text-gold-light hover:underline"
          >
            {t('bibliography.clearAll')} ({activeCount})
          </button>
        )}
      </header>

      <div>
        <h3 className="mb-2 text-[0.7rem] font-semibold uppercase tracking-[0.15em] text-ink-muted">
          {t('organizations.filter.country')}
        </h3>
        <select
          value={filters.country}
          onChange={(e) => update({ country: e.target.value })}
          className="form-input"
        >
          <option value="">{t('organizations.filter.allCountries')}</option>
          {facets.countries.map((c) => (
            <option key={c.name} value={c.name}>
              {c.name} ({c.count})
            </option>
          ))}
        </select>
      </div>
    </aside>
  );
}
